import { useState, useEffect } from 'react'
import { useSearchContext } from '../../../../../../providers/SearchContext'
import { useResponsive } from '../../../../../../providers/ResponsiveContext'
import dynamic from 'next/dynamic'

const Calendar = dynamic(
  () => import('../../../../../elements/form/Calendar'),
  {
    ssr: false,
    loading: () => <div>Loading calendar...</div>
  }
)

const Dates = ({
  form: { setFieldValue },
  property,
  blockedDates,
  minNights,
  translations
}) => {
  const { isDesktop } = useResponsive()
  const { search, setSearch, initialValues, offsetable } = useSearchContext()
  const [startDate, setStartDate] = useState(
    (offsetable === 0 && search?.startDate) || initialValues?.startDate
  )
  const [endDate, setEndDate] = useState(
    (offsetable === 0 && search?.endDate) || initialValues?.endDate
  )

  useEffect(() => {
    setStartDate(search.startDate)
    setEndDate(search.endDate)
    setFieldValue('startDate', startDate)
    setFieldValue('endDate', endDate)
  }, [search.startDate, search.endDate])

  useEffect(() => {
    setFieldValue('startDate', startDate)
    setFieldValue('endDate', endDate)
    setSearch &&
      setSearch((prevState) => ({
        ...prevState,
        endDate: endDate,
        startDate: startDate
      }))
  }, [startDate, endDate])

  return (
    <Calendar
      translations={translations}
      variant={['dark', 'large']}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      startDate={startDate}
      blockedDates={blockedDates}
      endDate={endDate}
      disabled={!property.is_active}
      minimumNights={minNights}
      clearable
      daySize={isDesktop ? 35 : 41}
      yearJump
    />
  )
}

export default Dates
